import React from 'react';

const DoubleDeckerBusSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 5H10V3H5.5C3.6 3 2 4.6 2 6.5V19h4c0 1.1.9 2 2 2s2-.9 2-2h5.6c0 1.1.9 2 2 2s2-.9 2-2H22V5zm-6 3h2V6h-2v2zm-3 0h2V6h-2v2zm-3 0h2V6h-2v2zM3 6.5C3 5.1 4.1 4 5.5 4H9v5h10V6h2v5H3V6.5zm7 7.5h2v-2h-2v2zm3 0h2v-2h-2v2zm3 0h2.3v-2H16v2zm3.3 0H21v-2h-1.7v2zM3 14h6v-2H3v2zm5 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.4 1-1 1zm9.6 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.5 1-1 1zm1.7-2c-.3-.6-1-1-1.7-1s-1.4.4-1.7 1H9.7c-.3-.6-1-1-1.7-1s-1.4.4-1.7 1H3v-3h18v3h-1.7z"
        />
    </svg>
);

DoubleDeckerBusSvg.displayName = 'DoubleDeckerBusSvg';
export default DoubleDeckerBusSvg;
